import { toast } from 'sonner';
import i18n from 'i18next';
import axiosInstance from '../lib/axios-instance';

export type TGetEmailRefundRes = {
  error: boolean;
  data: {
    email: string;
    facility_id: number;
    created_at: Date;
    id: number;
    client_transaction_id: string;
    refund_to_fullname: string;
    first_name: string;
    refund_to_address_line1: string;
    refund_to_address_line2: string;
    refund_region: string;
    refund_guarantor_name: string;
    refund_to_city: string;
    refund_to_state: string;
    refund_to_zip: string;
    last_name: string;
    organization_specific1: string;
    organization_specific2: string;
    organization_specific3: string;
    email_sent: string;
    email_sent_date: string;
    account_holder_name: string;
    routing_number: string;
    account_number: string;
    bank_name: string;
    payee_account_number: string;
    vendor_id_number: string;
    phone: string;
    refund_date: string;
    refund_amount: string;
    refund_status: string;
    filename: string;
    email_subscription: boolean;
    refund_method: string;
    status_updatedat: Date;
    refund_transaction_id: string;
    otp_created_at: string;
    otp_attempts: number;
    otptoken: string;
    econsent: boolean;
    additional_info: string;
    status_updated_current: Date;
    business_unit_identifier: string;
    business_unit_id: number;
    refund_to_country: string;
    refund_sub_status: string;
    transaction_id: string;
    updated_by: string;
    updated_at: Date;
    is_error: boolean;
  };
};

export const claimCheck = async ({
  isUpdated,
  address,
  isAddressUpdateAllowed,
}: {
  isUpdated: boolean;
  address: {
    refund_to_address_line1: string;
    refund_to_address_line2: string;
    refund_to_city: string;
    refund_to_zip: string;
    refund_to_state: string;
    refund_to_country: string;
  };
  isAddressUpdateAllowed: boolean;
}): Promise<{ message: string }> => {
  try {
    const res = await axiosInstance.post(`add-check`, {
      address: { is_updated: isUpdated, ...address },
    });

    return res.data;
  } catch (e: any) {
    if (
      e.response?.status === 400 &&
      e.response?.data?.invalidAddress === true
    ) {
      if (isAddressUpdateAllowed) {
        toast.error(
          i18n.t('USPS Address validation has failed - ERR', {
            errorMessage: e.response?.data?.invalidAddressMessage,
          }),
        );
      } else {
        toast.error(
          i18n.t('USPS Address validation has failed customer support'),
        );
      }
    }

    throw new Error('Failed to get email payment details');
  }
};
